export default __webpack_public_path__ + "static/media/cheese-1.c666abf6.png";